import { BaseModel } from "./base";
import { TipoProcesso } from "./tipo_processo";
import { TipoAtendimento } from "./tipo_atendimento";
import { Acampanhamento } from "./acompanhamento";

export class Processo extends BaseModel {
  constructor(
    public id: number,
    public tipoProcesso: TipoProcesso,
    public tipoAtendimento: TipoAtendimento,
    public acompanhamentos: Acampanhamento[]
  ) {
    super(id);
  }
}
